import { useState } from "react";
import { pinJSONToIPFS, pinFileToIPFS } from "../models/pinata";
// eslint-disable-next-line
import { getProjectMetaData } from "../models/project";
import { checkSimpleUndefined } from "../utils/formValidation";
import { uploadImage } from "@airdrop/models/image";

export const usePinata = () => {
  const [pinataError, setPinataError] = useState("");
  const [pinataStatus, setPinataStatus] = useState("unfinished");

  const uploadForm = async (props) => {
    const baseDataPromise = async (formToSubmit) => {
      const imgData = new FormData();
      imgData.append("file", formToSubmit.thumbnail);
      checkSimpleUndefined(imgData);
      const imgResult = await pinFileToIPFS(imgData);

      const baseData = {
        description: formToSubmit.description,
        image: "ipfs://" + imgResult.data.IpfsHash,
        website_url: formToSubmit.website_url,
      };
      if (formToSubmit.twitter_url) {
        baseData["twitter_url"] = formToSubmit.twitter_url;
      }
      if (formToSubmit.discord_url) {
        baseData["discord_url"] = formToSubmit.discord_url;
      }
      if (formToSubmit.opensea_url) {
        baseData["opensea_url"] = formToSubmit.opensea_url;
      }
      checkSimpleUndefined(baseData);
      const baseResult = await pinJSONToIPFS(baseData);
      setPinataStatus("baseDataUploaded");
      return "ipfs://" + baseResult.data.IpfsHash;
    };

    const frozenDataPromise = async (
      initSubmitForm,
      generateProjMetaDataForm,
      generateFrozenDataForm
    ) => {
      try {
        const projMetaDataForm = generateProjMetaDataForm(initSubmitForm);
        checkSimpleUndefined(projMetaDataForm);
        // console.log('projMetaDataForm:', projMetaDataForm);
        const claimResult = await getProjectMetaData(projMetaDataForm);
        // console.log('claimResult:', claimResult);
        // const frozenData = generateFrozenDataForm(initSubmitForm, {});
        const frozenData = generateFrozenDataForm(initSubmitForm, claimResult);
        checkSimpleUndefined(frozenData);
        const frozenResult = await pinJSONToIPFS(frozenData);
        // console.log('frozenResult:', frozenResult);
        setPinataStatus("frozenDataUploaded");
        return ["ipfs://" + frozenResult.data.IpfsHash, claimResult.merkleRoot];
      } catch (err) {
        console.log("err:", err);
        throw err;
      }
    };

    const { initSubmitForm, generateProjMetaDataForm, generateFrozenDataForm } =
      props;

    try {
      const hashs = await new Promise((resolve, reject) => {
        Promise.all([
          baseDataPromise(initSubmitForm),
          frozenDataPromise(
            initSubmitForm,
            generateProjMetaDataForm,
            generateFrozenDataForm
          ),
        ])
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
        setTimeout(() => {
          reject(new Error("Upload Pinata Time Out"));
        }, 300000);
      });
      setPinataStatus("FINISH");
      return hashs;
    } catch (err) {
      setPinataStatus("error");
      setPinataError(err);
      throw new Error(err.message);
    }
  };
  const uploadEditForm = async (props) => {
    const baseDataPromise = async (formToSubmit) => {
      console.log("formToSubmit:", formToSubmit);
      const imgData = new FormData();
      let imgResult = "";

      // check if user upload a new image
      if (!formToSubmit.thumbnail.toString().startsWith("ipfs://")) {
        imgData.append("file", formToSubmit.thumbnail);
        checkSimpleUndefined(imgData);
        imgResult = await pinFileToIPFS(imgData);
      }
      const imgHash = imgResult?.data?.IpfsHash;
      if (imgResult !== undefined) {
        // Fix me - this try catch is to make sure that if the image is not successfully uploaded to AWS,
        // the user will not get blocked by errors
        try {
          await uploadImage(pinata_address + imgHash);
          console.log("Compressd Image uploaded");
        } catch (err) {
          console.log("err:", err);
        }
      }
      // console.log(imgResult);
      const baseData = {
        description: formToSubmit.description,
        website_url: formToSubmit.website_url,
      };
      // if user upload did not change the image keep the old ipfs hash
      if (formToSubmit.thumbnail.toString().startsWith("ipfs://")) {
        baseData["image"] = formToSubmit.thumbnail.toString();
      } else {
        // else use the new ipfs hash
        baseData["image"] = "ipfs://" + imgResult?.data?.IpfsHash;
      }
      if (formToSubmit.twitter_url) {
        baseData["twitter_url"] = formToSubmit.twitter_url;
      }
      if (formToSubmit.discord_url) {
        baseData["discord_url"] = formToSubmit.discord_url;
      }
      if (formToSubmit.opensea_url) {
        baseData["opensea_url"] = formToSubmit.opensea_url;
      }
      checkSimpleUndefined(baseData);
      const baseResult = await pinJSONToIPFS(baseData);
      setPinataStatus("baseDataUploaded");
      return "ipfs://" + baseResult?.data?.IpfsHash;
    };
    console.log("props:", props);
    try {
      const hashs = await new Promise((resolve, reject) => {
        Promise.all([baseDataPromise(props)]).then((result) => {
          resolve(result);
        });
        setTimeout(() => {
          reject(new Error("Upload Pinata Time Out"));
        }, 300000);
      });
      setPinataStatus("FINISH");
      return hashs;
    } catch (err) {
      setPinataError(err);
      throw new Error(err.message);
    }
  };
  return {
    pinataStatus,
    pinataError,
    uploadForm,
    uploadEditForm,
    setPinataStatus,
  };
};
